<template>
    <div id="product-sentiments">
        <div v-show="loader || modalLoader || sentimentLoader || savedViewLoader">
            <Loader />
        </div>
        <div class="card datepickerwrap mt-4 d-flex flex-row justify-content-between">
            <div class="d-flex flex-row gap">
                <div>
                    <div class="mb-1 ml-1 label">Date Range</div>
                    <date-range-picker v-model="dateRange" :show-dropdowns="true" opens='right' :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate"
                        :ranges="false">
                    </date-range-picker>
                </div>
                <div class="customSelect" v-if="platforms.length">
                    <div class="mb-1 ml-1 label">Platform</div>
                    <select v-model="selectedPlatform" @change="changePlatform"
                        class="form-control text-uppercase platform-select">
                        <option v-for="platform of platforms" :key="platform.platform_link" :value="platform">
                            {{ platform.platform_name.replaceAll("_", " ") }}
                        </option>
                    </select>
                </div>
                <div v-if="Object.keys(categories).length">
                    <div class="mb-1 ml-1 label">Category</div>
                    <div class="customMultiselect" style="width: 250px;">
                        <multiselect v-model="selectedCategory" :options="categories[selectedPlatform.platform_name]"
                            :multiple="false" :searchable="false" placeholder="Select Categories" label="value"
                            track-by="key" :showLabels="false" :close-on-select="true" @input="changeCategory">
                            <template #selection="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                                    {{ values.length }} options selected
                                </span>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="d-flex flex-row align-items-center gap" style="margin-top: 20px;">
                    <!-- Filter and Download Buttons -->
                    <button class="btn primarycolor" @click="applyFilters">
                        Apply Filters
                    </button>
                    <button class="btn navigation-btn" @click="goToProductReviews">
                        Back
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex justify-content-start mt-2" v-if="selectedView">
                    <div class="graphHeading pb-2 mr-3">{{ selectedView.view_name }}</div>
                    <div class="cursor-pointer" @click="openViewModal('Edit View')">
                        <img src="../../../public/Icons_SVG/editBtn.svg" style="width: 15px; height: 15px;" />
                    </div>
                    <div class="cursor-pointer ml-3" @click="showDeleteModal = true">
                        <img src="../../../public/Icons_SVG/deleteBtnSvg.svg" style="width: 15px; height: 15px;;" />
                    </div>
                </div>
                <div v-else class="grayedHeading mt-2">Unsaved View</div>
                <div class="d-flex justify-content-end align-items-end">
                    <div style="margin-inline: 0.5rem;">
                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Select View
                            Name</div>
                        <div class="customMultiselect" style="width:250px; margin-bottom: -5px;">
                            <multiselect v-model="selectedView" :options="viewOptions" :multiple="false"
                                :searchable="false" placeholder="Select View" label="view_name" track-by="view_id"
                                :showLabels="false" :close-on-select="true" :allow-empty="false"
                                @input="getSelectedSavedView">
                            </multiselect>
                        </div>
                    </div>
                    <div class="d-flex align-items-end">
                        <button @click="resetSavedView" class="btn primarycolor mr-2 d-flex item-items-center">
                            <span class="newComparisonIcon">
                                <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path
                                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                                    </path>
                                </svg>
                            </span>
                            <span>Add New View</span>
                        </button>
                    </div>
                    <div class="d-flex justify-content-end align-items-center">
                        <button class="btn navigation-btn" @click="openViewModal('Save View')">
                            <span>Save View</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <div class="ml-1 mr-2" v-if="comparisonList.length && !savedViewLoader">
            <b-row no-gutters>
                <b-col cols="4" class="px-1">
                    <div>
                        <div class="compare-card">
                            <b-row>
                                <b-col>
                                    <LogoContainer :imgSrc="comparisonList[0].img"
                                        :placeholder="comparisonList[0].img ? false : true" :imageHeight="170" />
                                </b-col>
                                <b-col class="px-2 d-flex flex-column justify-content-between">
                                    <div class="mb-4 mt-2" style="font-size: 16px;">
                                        <span class="font-weight-bold text-capitalize" style="color: #065559;">{{
                                            selectedCategory.value }}:
                                        </span>
                                        <span class="text-capitalize">{{
                                            comparisonList[0].selectedProduct &&
                                            comparisonList[0].selectedProduct.split("+")[0]
                                        }}</span>
                                        <div class="mt-2" style="color: #5e5e5e;">{{
                                            comparisonList[0].selectedProduct &&
                                                comparisonList[0].selectedProduct.split("+")[0]
                                                ===
                                                client
                                                ? 'Primary Product'
                                                : 'Competitor Product'
                                        }}</div>
                                    </div>
                                    <div style="width: 95%;">
                                        <Treeselect v-if="allProducts[selectedPlatform.platform_name].length"
                                            v-model="comparisonList[0].selectedProduct" :options="allProducts[selectedPlatform.platform_name]"
                                            placeholder="Select Product" :multiple="false"
                                            @input="getProductSentiments(0)" :clearable="false"
                                            :disableBranchNodes="true" :searchable="true">
                                            <span slot="noResult">Oops! No elements found. Consider changing the
                                                search
                                                query.</span>
                                            <label slot="option-label" slot-scope="{node, labelClassName}"
                                                :title="node.label" :class="{
                                                    'text-truncate d-flex align-items-center text-capitalize': !node.isBranch,
                                                    'tree-leaf': node.isBranch
                                                }">{{ node.label }}</label>
                                        </Treeselect>
                                    </div>
                                </b-col>
                            </b-row>
                            <div v-if="Object.keys(comparisonList[0].wordCloud).length">
                                <div class="d-flex justify-content-between align-items-center positive-heading">
                                    <h3 class="mb-0">Positive Sentiments</h3>
                                    <div class="customSelect">
                                        <select class="form-control text-capitalize platform-select"
                                            v-model="comparisonList[0].selectedPositiveCloudLimit"
                                            @change="getProductSentiments(0)">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                        </select>
                                    </div>
                                </div>
                                <WordCloud v-if="comparisonList[0].wordCloud.positive.length"
                                    :cloudData="comparisonList[0].wordCloud.positive" :comparisonIndex="0" color="#065559" @analyse-keyword="openCompPositiveModal" :categoryName="comparisonList[0].selectedProduct" />
                                <div v-else style="height: 350px;">
                                    <div class="px-4 py-2" style="color: var(--red-80);">No Data</div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center negative-heading">
                                    <h3 class="mb-0">Negative Sentiments</h3>
                                    <div class="customSelect">
                                        <select class="form-control text-capitalize platform-select"
                                            v-model="comparisonList[0].selectedNegativeCloudLimit"
                                            @change="getProductSentiments(0)">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                        </select>
                                    </div>
                                </div>
                                <WordCloud v-if="comparisonList[0].wordCloud.negative.length"
                                    :cloudData="comparisonList[0].wordCloud.negative" :comparisonIndex="0" color="#FD5542" @analyse-keyword="openCompNegativeModal" :categoryName="comparisonList[0].selectedProduct" />
                                <div v-else style="height: 350px;">
                                    <div class="px-4 py-2" style="color: var(--red-80);">No Data</div>
                                </div>
                            </div>
                        </div>
                        <div class="section-card mt-3 pb-2 bg-white" v-if="comparisonList[0].keywordTable.length">
                            <p class="heading">All Sentiments</p>
                            <div>
                                <table id="sentiment-table-0" class="w-100 mt-4">
                                    <thead>
                                        <tr>
                                            <th>Keyword</th>
                                            <th>Frequency</th>
                                            <th>Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row of comparisonList[0].keywordTable">
                                            <td>
                                                <span class="keyword" role="button" tabindex="0"
                                                    @click="openModal(row.word, comparisonList[0].selectedProduct)">
                                                    {{ row.word }}
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <div
                                                    style="font-family: Heebo; font-size: 16px; font-weight: 400; color: #065559;">
                                                    {{ row.positive_frequency }}
                                                </div>
                                                <div
                                                    style="font-family: Heebo; font-size: 16px; font-weight: 400; color: #D90000;">
                                                    {{ row.negative_frequency }}
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <GaugeChart :rawData="row" />
                                                </div>
                                            </td>
                                            <td>{{ row.positive_frequency + row.negative_frequency }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="8">
                    <div class="d-flex w-100 px-1 thin-scroller"
                        style="overflow-x: scroll; overflow-y: hidden; min-height: 100%;">
                        <div v-for="index in 5" class="mx-1" :id="'compare-card-' + index" style="min-width: 50%;"
                            v-if="comparisonList[index]">
                            <div>
                                <div class="compare-card">
                                    <b-row>
                                        <b-col>
                                            <LogoContainer :imgSrc="comparisonList[index].img"
                                                :placeholder="comparisonList[index].img ? false : true"
                                                :imageHeight="170" />
                                        </b-col>
                                        <b-col class="px-2 d-flex flex-column justify-content-between">
                                            <div class="mb-4 mt-2" style="font-size: 16px;">
                                                <span class="font-weight-bold text-capitalize"
                                                    style="color: #065559;">{{
                                                        selectedCategory.value }}:
                                                </span>
                                                <span class="text-capitalize">{{
                                                    comparisonList[index].selectedProduct &&
                                                    comparisonList[index].selectedProduct.split("+")[0]
                                                }}</span>
                                                <div class="mt-2" style="color: #5e5e5e;">{{
                                                    comparisonList[index].selectedProduct &&
                                                        comparisonList[index].selectedProduct.split("+")[0] ===
                                                        client
                                                        ? 'Primary Product'
                                                        : 'Competitor Product'
                                                }}</div>
                                            </div>
                                            <div style="width: 95%;">
                                                <Treeselect v-if="allProducts[selectedPlatform.platform_name].length"
                                                    v-model="comparisonList[index].selectedProduct"
                                                    :options="allProducts[selectedPlatform.platform_name]" placeholder="Select Product"
                                                    :multiple="false" @input="getProductSentiments(index)"
                                                    :clearable="false" :disableBranchNodes="true" :searchable="true">
                                                    <span slot="noResult">Oops! No elements found. Consider changing the
                                                        search
                                                        query.</span>
                                                    <label slot="option-label" slot-scope="{node, labelClassName}"
                                                        :title="node.label" :class="{
                                                            'text-truncate d-flex align-items-center text-capitalize': !node.isBranch,
                                                            'tree-leaf': node.isBranch
                                                        }">{{ node.label }}</label>
                                                </Treeselect>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <div v-if="Object.keys(comparisonList[index].wordCloud).length">
                                        <div class="d-flex justify-content-between align-items-center positive-heading">
                                            <h3 class="mb-0">Positive Sentiments</h3>
                                            <div class="customSelect">
                                                <select class="form-control text-capitalize platform-select"
                                                    v-model="comparisonList[index].selectedPositiveCloudLimit"
                                                    @change="getProductSentiments(index)">
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                </select>
                                            </div>
                                        </div>
                                        <WordCloud v-if="comparisonList[index].wordCloud.positive.length"
                                            :cloudData="comparisonList[index].wordCloud.positive" :comparisonIndex="index" color="#065559" @analyse-keyword="openCompPositiveModal" :categoryName="comparisonList[index].selectedProduct" />
                                        <div v-else style="height: 350px;">
                                            <div class="px-4 py-2" style="color: var(--red-80);">No Data</div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center negative-heading">
                                            <h3 class="mb-0">Negative Sentiments</h3>
                                            <div class="customSelect">
                                                <select class="form-control text-capitalize platform-select"
                                                    v-model="comparisonList[index].selectedNegativeCloudLimit"
                                                    @change="getProductSentiments(index)">
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                </select>
                                            </div>
                                        </div>
                                        <WordCloud v-if="comparisonList[index].wordCloud.negative.length"
                                            :cloudData="comparisonList[index].wordCloud.negative" :comparisonIndex="index" color="#FD5542" @analyse-keyword="openCompNegativeModal" :categoryName="comparisonList[index].selectedProduct" />
                                        <div v-else style="height: 350px;">
                                            <div class="px-4 py-2" style="color: var(--red-80);">No Data</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-card mt-3 pb-2 bg-white"
                                    v-if="comparisonList[index].keywordTable.length">
                                    <p class="heading">All Sentiments</p>
                                    <div>
                                        <table :id="'sentiment-table-' + index" class="w-100 mt-4">
                                            <thead>
                                                <tr>
                                                    <th>Keyword</th>
                                                    <th>Frequency</th>
                                                    <th>Score</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="row of comparisonList[index].keywordTable">
                                                    <td>
                                                        <span class="keyword" role="button" tabindex="0"
                                                            @click="openModal(row.word, comparisonList[index].selectedProduct)">
                                                            {{ row.word }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <div
                                                            style="font-family: Heebo; font-size: 16px; font-weight: 400; color: #065559;">
                                                            {{ formatNumber(row.positive_frequency) }}
                                                        </div>
                                                        <div
                                                            style="font-family: Heebo; font-size: 16px; font-weight: 400; color: #D90000;">
                                                            {{ formatNumber(row.negative_frequency) }}
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="d-flex justify-content-center align-items-center">
                                                            <GaugeChart :rawData="row" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="comparisonList.length < 5" class="d-flex"
                            :style="comparisonList.length < 2 ? 'min-width: 90%;' : 'min-width: 45%;'">
                            <div class="add-comparison mx-1 w-100">
                                <div class="plus-icon" @click="prepareComparisonList">
                                    +
                                </div>
                                <div style="font-size:16px; font-weight: 500;">
                                    Add Product
                                </div>
                            </div>
                            <div class="add-comparison" v-if="comparisonList.length < 2"
                                :style="comparisonList.length === 2 ? 'min-width: 50%' : 'min-width: 45%'">
                                <div class="plus-icon" @click="prepareComparisonList">
                                    +
                                </div>
                                <div style="font-size:16px; font-weight: 500;">
                                    Add Product
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-modal v-model="keywordModal" size="xl" :title="modalTitle" @hidden="resetModal">
            <div class="modal-control-panel mt-3">
                <ul>
                    <li v-for="tab of modalTabs" :key="tab" @click="selectedModalTab = tab"
                        :class="{ 'selected-tab': tab === selectedModalTab }">{{ tab
                        }}</li>
                </ul>
                <div class="d-flex" style="margin-top: -16px;">
                    <b-button-toolbar aria-label="Toolbar with buttons group"
                        v-show="selectedModalTab === 'Frequency' || selectedModalTab === 'Score' || selectedModalTab === 'Review Count'">
                        <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons
                            button-variant="outline-secondary" @change="updateCatSentimentData" v-model="keywordInterval"
                            name="radiosBtn">
                            <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                            <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                        </b-form-radio-group>
                    </b-button-toolbar>
                    <date-range-picker v-model="modalDateRange" :show-dropdowns="true" opens='right' :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate" :ranges="false"
                        @update="updateCatModal">
                    </date-range-picker>
                </div>
            </div>
            <div v-if="Object.keys(keywordWiseSentiments).length">
                <KeywordModalCard :selectedTab="selectedModalTab" :keywordReview="keywordWiseReviews"
                    :keywordSentiment="keywordWiseSentiments" :keywordTreeData="keywordTreeData"
                    @filter-reviews="filterReviews" @toggle-node="toggleTreeNode" />
            </div>
            <!-- <div class="modal-control-panel">
                <h6>{{ selectedkeywordChartMetric.label }}</h6>
                <div class="d-flex" style="gap: 6px;">
                    <select class="customselect w-25" v-model="selectedkeywordChartMetric">
                        <option v-for="metric of keywordChartMetric" :key="metric.key" :value="metric">{{
                            metric.label
                        }}
                        </option>
                    </select>
                    <b-button-toolbar aria-label="Toolbar with buttons group">
                        <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons
                            button-variant="outline-secondary" @change="updateCatSentimentData"
                            v-model="keywordInterval" name="radiosBtn">
                            <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                            <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                        </b-form-radio-group>
                    </b-button-toolbar>
                    <date-range-picker v-model="modalDateRange" :show-dropdowns="true" opens='right' :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate" :ranges="false"
                        @update="updateCatModal">
                    </date-range-picker>
                </div>
            </div>
            <div v-if="Object.keys(keywordWiseSentiments).length">
                <KeywordModalCard :keywordReview="keywordWiseReviews" :keywordSentiment="keywordWiseSentiments"
                    :chartKey="selectedkeywordChartMetric.key" @filter-reviews="filterReviews" />
            </div> -->
        </b-modal>
        <b-modal size="md" class="customModal" hide-footer style="z-index: 3000 !important; text-transform: capitalize"
            v-model="showViewModal" :title="viewModalName">
            <div class="customMultiselect" v-if="viewModalName === 'Save View'">
                <multiselect v-model="selectedModalView" :options="modalViewOptions" :multiple="false"
                    :searchable="false" placeholder="Select View" label="view_name" track-by="view_id"
                    :showLabels="false" :close-on-select="true" :allow-empty="false">
                </multiselect>
            </div>
            <input required type="text" v-model="newViewName" class="text-capitalize customInput px-2"
                v-show="viewModalName === 'Edit View' || (viewModalName === 'Save View' && selectedModalView.view_id === 'add_new')" />
            <div class="d-flex justify-content-end align-items-center mt-3">
                <button class="btn navigation-btn" :disabled="spinLoader" @click="saveCompareView">
                    <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
                    <span>Save View</span>
                </button>
            </div>
        </b-modal>
        <b-modal title="Delete View" v-model="showDeleteModal" class="container-modal-ASIN">
            <div class="modal-delete-content d-flex align-items-start mb-2">
                <div class="delete-alert text-center rounded-circle px-2 mr-3">&#9888;</div>
                <div>You're going to delete this View from the View List.<br>Are you sure ?</div>
            </div>
            <div class="d-flex justify-content-end">
                <b-button @click="showDeleteModal = false" class="btn primarycolor">No, Keep It.</b-button>
                <button @click="deleteView" :disabled="spinLoader"
                    class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-viewBtn"
                    style="background-color: var(--red)">
                    <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
                    <span>Yes, Delete!</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import LogoContainer from "../ReviewsAndRatings/Components/LogoContainer.vue"
import WordCloud from '../commonCharts/WordCloud.vue';
import GaugeChart from '../commonCharts/GaugeChart.vue';
import KeywordModalCard from '../ReviewsAndRatings/Components/KeywordModalCard.vue';
import Loader from '../Components/Loader.vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
    name: 'ProductSentiments',
    components: {
        Treeselect,
        Multiselect,
        LogoContainer,
        WordCloud,
        GaugeChart,
        KeywordModalCard,
        Loader
    },
    data() {
        return {
            loader: false,
            modalLoader: false,
            sentimentLoader: false,
            spinLoader: false,
            savedViewLoader: false,
            dateRange: {
                startDate: moment().startOf('year').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
            modalDateRange: {
                startDate: moment().startOf('year').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
            maxDate: new Date(),
            minDate: new Date(moment().subtract(3, 'years')),
            client: JSON.parse(localStorage.reviewUserData).data.client,
            platforms: [],
            selectedPlatform: "",
            categories: {},
            selectedCategory: {},
            comparisonList: [],
            keywordModal: false,
            selectedModalKeyword: "",
            modalTitle: "",
            keywordWiseReviews: [],
            keywordWiseSentiments: {},
            keywordTreeData: {},
            modalTabs: [
                "Reviews",
                "Frequency",
                // "Score",
                "Review Count",
                // "Tree Structure",
                "Contribution tree"
            ],
            selectedModalTab: "Reviews",
            keywordInterval: 'month',
            selectedModalBrand: '',
            selectedModalProduct: '',
            allProducts: [],
            defaultComparisonProduct: null,
            savedViews: [],
            viewOptions: [],
            selectedView: "",
            showViewModal: false,
            viewModalName: "",
            showDeleteModal: false,
            newViewName: "",
            selectedModalView: {
                view_id: 'add_new',
                view_name: 'Add New'
            },
            modalViewOptions: [],
        }
    },
    mounted() {
        this.getPlatformsAndCategories();
    },
    methods: {
        formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        goToProductReviews() {
            this.comparisonList = [];
            this.$router.push("/reviews/product");
        },
        applyFilters() {
            this.modalDateRange = this.dateRange;
            for (let itemIndex in this.comparisonList) {
                this.getProductSentiments(itemIndex);
            }
        },
        prepareComparisonList() {
            if (!this.comparisonList.length) {
                this.comparisonList.push({
                    selectedProduct: this.defaultComparisonProduct,
                    wordCloud: {},
                    keywordTable: [],
                    img: "",
                    selectedPositiveCloudLimit: 10,
                    selectedNegativeCloudLimit: 10
                })
                this.getProductSentiments(0);
            } else {
                this.comparisonList.push({
                    selectedProduct: null,
                    wordCloud: {},
                    keywordTable: [],
                    img: "",
                    selectedPositiveCloudLimit: 10,
                    selectedNegativeCloudLimit: 10
                })
            }

            this.$nextTick(() => {
                if (this.comparisonList.length > 1 && this.comparisonList.length < 5) {
                    document.getElementById(`compare-card-${this.comparisonList.length - 1}`).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                    const main = document.getElementsByTagName('main');
                    main.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                }
            })

        },
        getPlatformsAndCategories() {
            this.platforms = [];
            this.selectedPlatform = "";
            this.categories = {};
            this.selectedCategory = [];

            const url = "/api/v2/india_clients/product_platform_details";
            const payload = {
                client: this.client,
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                non_sov: true
            }

            this.loader = true;

            this.$http.post(url, payload).then(res => {
                this.loader = false;
                this.platforms = res.body.data.platform;
                this.selectedPlatform = this.platforms[0];
                this.categories = res.body.data.category;
                this.selectedCategory = this.categories[this.selectedPlatform.platform_name][0]
                this.getAllProducts();
            }).catch(err => {
                this.loader = false
                console.log("Error in fetching platforms and categories", err)
            })
        },
        getAllProducts() {
            const url = "/api/v2/indian_clients/product_brand";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_name,
                category: this.selectedCategory.key,
                label: "product"
            }

            this.loader = true;
            this.$http.post(url, payload).then(res => {
                res.body.data[this.selectedPlatform.platform_name].map(brand => {
                    brand.children.map((product, index) => {
                        product.id = `${brand.id}+${product.id}`;
                        if (brand.id === this.client && index === 0) {
                            this.defaultComparisonProduct = product.id
                        }
                        // This check is only for demo account, can be removed later if fouund a good solution
                        else if (this.client === 'lyxel_labs') {
                            if (brand.id === 'godrej') {
                                this.defaultComparisonProduct = product.id;
                            }
                        }
                    })
                })

                this.allProducts = res.body.data;

                this.getSavedViews();

                this.loader = false;
            }).catch(err => {
                this.loader = false;
                console.log("Error in getting all products", err)
            })
        },
        getProductSentiments(index = 0) {
            $(`#sentiment-table-${index}`).DataTable().destroy();

            const productDetails = this.comparisonList[index].selectedProduct.split("+");
            const brandName = productDetails[0];
            const productName = productDetails[1];

            this.comparisonList[index].ratingsData = {};
            this.comparisonList[index].sentiments = [];

            const url = "/api/v2/indian_clients/compare_data";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_name,
                compare: [{
                    brand_name: brandName,
                    category_name: this.selectedCategory.key,
                    product_id: productName
                }],
                compare_type: "product",
                positive_limit: Number(this.comparisonList[index].selectedPositiveCloudLimit),
                negative_limit: Number(this.comparisonList[index].selectedNegativeCloudLimit)
            }

            this.sentimentLoader = true;

            this.$http.post(url, payload).then(res => {
                this.sentimentLoader = false;
                this.comparisonList[index].wordCloud = res.body.data[productName].sentiment.word_clowd;
                this.comparisonList[index].keywordTable = res.body.data[productName].sentiment.table;
                this.comparisonList[index].img = res.body.data[productName].product_image;

                this.$nextTick(() => {
                    this.processTable(`#sentiment-table-${index}`)
                })
            }).catch(err => {
                this.sentimentLoader = false;
                console.log(`Error in getting product review`, err);
            })
        },
        openCompNegativeModal(keyword, productName, compIndex) {
            this.openModal(keyword, productName, 'negative');
        },
        openCompPositiveModal(keyword, productName, compIndex) {
            this.openModal(keyword, productName, 'positive');
        },
        openModal(targetKeyword, productName, sentType="") {

            const selectedProductDetails = productName.split("+");
            this.selectedModalBrand = selectedProductDetails[0]
            this.selectedModalProduct = selectedProductDetails[1];

            this.selectedModalKeyword = targetKeyword;
            this.modalTitle = `Keyword : ${targetKeyword}`;

            this.getKeywordReviews(sentType);
            this.getKeywordSentiment();

            this.$nextTick(() => {
                this.keywordModal = true;
            })
        },
        resetModal() {
            this.selectedModalKeyword = "";
            this.modalTitle = "";
            this.keywordWiseReviews = [];
            this.keywordWiseSentiments = {};
            this.selectedkeywordChartMetric = {
                label: 'Frequency',
                key: 'frequency'
            };
            this.keywordInterval = 'month';
            this.selectedModalProduct = "";
            this.selectedModalBrand = "";
        },
        updateCatModal() {
            this.getKeywordReviews();
            this.getKeywordSentiment();
        },
        filterReviews(sentimentType) {
            this.getKeywordReviews(sentimentType);
        },
        updateCatSentimentData() {
            this.$nextTick(() => {
                this.getKeywordSentiment();
            })
        },
        getKeywordReviews(sentimentType) {
            const url = "/api/v2/indian_clients/keyword_reviews_data";
            const payload = {
                start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
                keyword: this.selectedModalKeyword,
                client: this.client,
                channel: this.selectedPlatform.platform_name,
                brand_name: [this.selectedModalBrand],
                category_name: [this.selectedCategory.key],
                product_name: [this.selectedModalProduct],
                limit: 50,
                offset: 0,
                sentiment_type: sentimentType || 'positive'
            };

            this.keywordWiseReviews = []
            this.modalLoader = true;

            this.$http.post(url, payload).then(res => {
                this.modalLoader = false;
                this.keywordWiseReviews = res.body.data;
            }).catch(err => {
                this.modalLoader = false;
                console.log(`Error in fetching keyword reviews`, err);
            });
        },
        getKeywordSentiment() {
            const url = "/api/v2/indian_clients/keyword_sentiments_data";
            const payload = {
                start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
                keyword: this.selectedModalKeyword,
                interval: this.keywordInterval,
                client: this.client,
                channel: this.selectedPlatform.platform_name,
                brand_name: [this.selectedModalBrand],
                category_name: [this.selectedCategory.key],
                product_name: [this.selectedModalProduct],
            };

            this.keywordWiseSentiments = {};
            this.modalLoader = true;

            this.$http.post(url, payload).then(res => {
                this.modalLoader = false;
                this.keywordWiseSentiments = res.body.data;
            }).catch(err => {
                this.modalLoader = false;
                console.log(`Error in fetching keyword sentiments`, err)
            })
        },
        processTable(id) {
            if ($.fn.DataTable.isDataTable(id)) {

            }
            $(id).DataTable({
                initComplete: function (settings, json) {
                    $('.dataTables_scrollBody tfoot tr').css({ visibility: 'collapse' });
                    $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
                    $(id).wrap("<div class='thin-scroller' style='overflow:auto; width:100%;position:relative; max-height:600px'></div>");
                },
                columnDefs: [
                    { "orderData": 3, "targets": 1 },
                    { "visible": false, "targets": 3 },
                    { orderable: false, targets: 2 }
                ],
                language: {
                    search: "",
                    paginate: {
                        first: "",
                        previous: "<",
                        next: ">",
                        last: "",
                    },
                    lengthMenu: "<h5>Show entries</h5> _MENU_",
                    searchPlaceholder: "Search..."
                },

                pagingType: "full_numbers",
                searching: true,
                sorting: [[1, 'desc']],
                autoWidth: false,

            })

            let search = require("../../../public/Icons_SVG/Search.svg");
            $(id + "_filter > label").append(`<div><img src='${search}' /></div>`);

        },
        changePlatform() {
            this.selectedCategory = this.categories[this.selectedPlatform.platform_name][0];
            this.comparisonList = [];
            this.getAllProducts();
        },
        changeCategory() {
            this.comparisonList = [];
            this.getAllProducts();
        },
        getSelectedSavedView() {
            this.savedViewLoader = true;

            localStorage.savedView = this.selectedView.view_id;
            this.comparisonList = [];

            const targetView = this.savedViews.find(view => view.view_id === this.selectedView.view_id);

            this.dateRange = targetView.page_filter.dateRange;
            this.selectedPlatform = targetView.page_filter.selectedPlatform;
            this.selectedCategory = targetView.page_filter.selectedCategory;

            const compareBrandPayload = [];

            targetView.product_filter.map((brand, index) => {
                this.comparisonList.push({
                    selectedProduct: `${brand.selectedBrand}+${brand.selectedProduct}`,
                    ratingsData: {},
                    sentiments: [],
                    currentTab: "Sentiment Overview",
                    img: "",
                })

                compareBrandPayload.push({
                    brand_name: brand.selectedBrand,
                    category_name: this.selectedCategory.key,
                    product_name: brand.selectedProduct
                })

                $(`#sentiment-table-${index}`).DataTable().destroy();
            })

            this.$nextTick(() => {
                const url = "/api/v2/indian_clients/compare_data";
                const payload = {
                    start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                    end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                    client: this.client,
                    channel: this.selectedPlatform.platform_name,
                    compare: compareBrandPayload,
                    compare_type: "product",
                    positive_limit: 10,
                    negative_limit: 10
                };

                this.sentimentLoader = true;

                this.$http.post(url, payload).then(res => {
                    this.sentimentLoader = false;
                    this.comparisonList.forEach((brand, index) => {

                        const productName = brand.selectedProduct.split("+")[1];

                        this.comparisonList[index].wordCloud = res.body.data[productName].sentiment.word_clowd;
                        this.comparisonList[index].keywordTable = res.body.data[productName].sentiment.table;
                        this.comparisonList[index].img = res.body.data[productName].product_image;

                        this.$nextTick(() => {
                            this.processTable(`#sentiment-table-${index}`)
                        })
                    })
                }).catch(err => {
                    this.sentimentLoader = false;
                    console.log("Error in getting compare brand data", err)
                })
                this.savedViewLoader = false;
            });
        },
        resetViewModal() {
            this.viewModalName = "";
            this.newViewName = "";
            this.modalViewOptions = [];
            this.showViewModal = false;
        },
        openViewModal(viewType) {
            this.modalViewOptions = [
                ...this.viewOptions,
                {
                    view_id: 'add_new',
                    view_name: 'Add New'
                },
            ];

            if (viewType === 'Edit View') {
                this.newViewName = this.selectedView.view_name;
            } else if (viewType === 'Save View') {
                this.selectedModalView = {
                    view_id: 'add_new',
                    view_name: 'Add New'
                };

                this.newViewName = "";
            }

            this.$nextTick(() => {
                this.viewModalName = viewType;
                this.showViewModal = true;
            })
        },
        getSavedViews() {
            this.savedViews = [];
            this.viewOptions = [];
            const url = "/api/v2/reviews/comparison_view?view_for=product_reviews_compare";

            this.$http.get(url).then(res => {
                this.savedViews = res.data.data;
                if (this.savedViews.length) {
                    this.savedViews.map(view => {
                        this.viewOptions.push({
                            view_id: view.view_id,
                            view_name: view.view_name
                        })
                    })
                }

                if (!this.showViewModal) {
                    if (localStorage.savedView) {
                        this.selectedView = this.viewOptions.find(view => view.view_id === localStorage.savedView);

                        this.$nextTick(() => {
                            this.getSelectedSavedView();
                        })
                    } else {
                        this.prepareComparisonList();
                    }
                }

                if (
                    this.viewModalName === 'Edit View' ||
                    (
                        this.viewModalName === 'Save View' &&
                        this.selectedModalView.view_id === 'add_new'
                    )
                ) {
                    this.selectedView = this.viewOptions.find(view => view.view_name === this.newViewName);
                    localStorage.savedView = this.selectedView.view_id;
                    this.resetViewModal();
                } else this.resetViewModal();
            }).catch(err => {
                console.log(`Error getting saved views:: ${err}`);
            })
        },
        saveCompareView() {
            if (this.viewModalName === "Edit View" && !this.newViewName) {
                this.$bvToast.toast('Please provide a name to edit this view', {
                    title: 'Edit View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            } else if (this.selectedModalView.view_id === "add_new" && !this.newViewName) {
                this.$bvToast.toast('Please provide a name to save new view', {
                    title: 'Save View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            }

            this.spinLoader = true;

            if (this.newViewName) {
                let capitalizedText;
                capitalizedText = this.newViewName.split(' ').map(word =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                ).join(' ');

                this.newViewName = capitalizedText;
            }

            const url = "/api/v2/reviews/comparison_view";
            let payload = {
                view_for: "product_reviews_compare",
                view_data: {
                    page_filter: {
                        dateRange: {
                            startDate: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                            endDate: moment(this.dateRange.endDate).format("YYYY-MM-DD")
                        },
                        selectedPlatform: this.selectedPlatform,
                        selectedCategory: this.selectedCategory
                    },
                    product_filter: this.comparisonList.map(compareProduct => {
                        return {
                            selectedBrand: compareProduct.selectedProduct.split("+")[0],
                            selectedProduct: compareProduct.selectedProduct.split("+")[1]
                        }
                    }),
                    view_name: this.newViewName
                },
            };

            if (this.viewModalName === 'Edit View') {
                payload = {
                    ...payload,
                    view_id: this.selectedView.view_id
                }
            }

            if (this.viewModalName === 'Save View' && this.selectedModalView.view_id !== 'add_new') {
                payload.view_data.view_name = this.selectedModalView.view_name,
                    payload = {
                        ...payload,
                        view_id: this.selectedModalView.view_id
                    }
            }

            this.$http.post(url, payload).then(res => {
                this.getSavedViews();
                this.spinLoader = false;
            }).catch(err => {
                console.log(`Error in saving view::${err}`);
                this.spinLoader = false;
            });
        },
        resetComparisonList() {
            for (let index in this.comparisonList) {
                $(`#sentiment-table-${index}`).DataTable().destroy();
            }

            this.comparisonList = [];
            this.$nextTick(() => {
                this.prepareComparisonList();
            })
        },
        resetSavedView() {
            localStorage.removeItem("savedView");
            this.selectedView = "";
            this.resetComparisonList();
        },
        deleteView() {
            const url = "/api/v2/reviews/comparison_view";
            let payload = {
                view_id: [this.selectedView.view_id],
                view_for: "product_reviews_compare"
            }

            this.spinLoader = true;
            this.$http.delete(url, { body: payload }).then((res) => {

                this.getSavedViews();
                this.resetSavedView();

                this.$bvToast.toast('View deleted successfully', {
                    title: 'Delete View',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });

                this.spinLoader = false;

            }).catch((err) => {
                console.log(err);
                this.$bvToast.toast('Error in deleting this view', {
                    title: 'Delete View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                this.spinLoader = false;
            })

            this.showDeleteModal = false;
        },
    }
}
</script>
<style scoped>
.customInput {
    border-radius: 5px !important;
    height: 35px !important;
    border: 1px solid #e4e7ea;
    width: 220px;
    outline: none;
    font-family: 'poppins';
    width: 100%
}

.customInput:focus {
    border: 1px solid var(--primary_brand) !important;
    box-shadow: none !important;
}

.delete-viewBtn:hover {
    background-color: #f58181 !important;
}

.delete-alert {
    background-color: #ffecec !important;
    color: var(--red);
    font-size: 30px;
    width: 45px;
    height: 45px;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 16px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
    text-transform: capitalize;
}

.grayedHeading {
    font-weight: 600 !important;
    font-size: 16px !important;
    color: var(--base_color-60) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
    text-transform: capitalize;
}

.newComparisonIcon svg {
    height: 17px;
    transform: rotate(45deg);
    color: white;
    fill: #fff;
    margin-right: 5px;
}

.modal-control-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #D4D4D4;

    &>h6 {
        font-family: Poppins;
        font-size: 16px;
        font-weight: 500 !important;
        color: #000;
    }
}

.bg-white {
    background-color: white;
}

.heading {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.76px;
    letter-spacing: -0.01em;
    color: #5E5E5E;
    padding-bottom: 12px;
    border-bottom: 1px solid #D4D4D4;
    margin-block: 10px;
}

.keyword {
    color: #0463BA;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
    line-height: 25px;
    /* text-transform: capitalize; */
}

.section-card {
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    background-color: transparent;
    padding: 8px 16px;
    height: 100%;
}

.table-wrapper {
    max-height: 1015px;
    overflow-y: auto;
}

.positive-heading {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    color: #065559;
    background-color: #06555926;
    padding-inline: 8px;
    padding-block: 16px;
}

.negative-heading {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    color: #D90000;
    background-color: #D9000026;
    padding-inline: 8px;
    padding-block: 16px;
}

.add-comparison {
    border: 1px solid #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    height: 200px;
    border-radius: 10px;
    color: #5E5E5E;
}

.plus-icon {
    font-size: 30px;
    color: #5E5E5E;
    border: 2px dashed #5E5E5E;
    border-radius: 50%;
    padding-inline: 12px;
    cursor: pointer;
}

.logo-container {
    border-radius: 10px;
    border: 0px solid #D9D9D9;
    background: linear-gradient(360deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 1px 6px 0px #0000002E;
    max-height: 220px;
    max-width: 100%;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.customselect {
    height: 37px !important;
    border-radius: 5px !important;
    background: white;
    border: 1px solid #B7B7B7 !important;
    padding-left: 11px;
    padding-right: 11px;
    margin-right: 5px;
    color: var(--primary_brand);
    width: 90%;
    text-overflow: ellipsis;
}

.customselect:focus {
    outline: none !important;
    border: 1px solid var(--primary_brand) !important;
}

.compare-card {
    background-color: white;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 7px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 14px;
}

button.navigation-btn {
    background: var(--accent_color);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 7px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 14px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

button.navigation-btn:hover {
    background: var(--accent_color-80);
}

.label {
    font-size: 14px;
    font-weight: 500;
    color: #1E1E1E
}

.gap {
    gap: 14px !important;
}

.customSelect :focus {
    background: var(--base_color-5) !important;
    color: var(--primary_brand-60) !important;
    border: 1px solid var(--primary_brand-60) !important;
    outline: none !important;
    box-shadow: none !important;
    font-weight: 600;
}

.form-control {
    border-radius: 5px !important;
    padding: 6px !important;
    font-size: 11px !important;
    height: 35px !important;
    border: 1px solid var(--base_color-40) !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* datatable */
.dataTables_filter div {
    height: 35px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    margin-left: -15px;
    background-color: var(--primary_brand);
}

.dataTables_filter img {
    height: 17px;
    width: 35px;
    filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

table.dataTable th {
    background-color: #e7eeef !important;
    padding: 16px 32px !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 600 !important;
}

table.dataTable>thead>tr:first-child>th:first-child {
    border-top-left-radius: 5px !important;
}

table.dataTable>thead>tr:first-child>th:last-child {
    border-top-right-radius: 5px !important;
}

table.dataTable>tbody>tr>td {
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: black !important;
}

thead {
    background: none !important;
}

.dataTables_info {
    position: relative;
    top: 9px;
    left: 0;
    z-index: 100;
    float: none;
    width: auto;
    font-size: 15px;
    color: var(--primary_brand-80);
}

.dataTables_paginate {
    position: relative;
    top: 6px;
    z-index: 100;
    float: right;
    width: 50vw;
}

.customMultiselect .multiselect__placeholder {
    margin-bottom: 6px !important;
    padding: 0px !important;
    color: var(--primary_brand-40) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tags {
    border: 1px solid var(--base_color-40) !important;
    padding-top: 6px !important;
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select {
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
    top: 56% !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag {
    background: var(--primary_brand-80) !important;
    margin-bottom: 0px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
    color: #fff !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
    border: 1px solid var(--base_color-40) !important;
    border-top: none !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
    background: var(--red) !important;
    color: var(--white) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
    background: var(--base_color-20) !important;
    color: var(--primary_brand-80) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__element {
    color: var(--primary_brand-80) !important;
    border-bottom: 1px solid var(--base_color-20);
    font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
    width: 10px;
    border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
    background: var(--base_color-20);
    border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
    background: var(--base_color-80);
    border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
    background: var(--base_color);
}
</style>